import type {
  LoginRequest,
  LoginResponse,
  MeResponse,
  PasswordChangeRequest,
  PasswordChangeResponse,
} from '@/types/api';
import { apiFetch } from './client';

export function login(body: LoginRequest): Promise<LoginResponse> {
  return apiFetch<LoginResponse>('/auth/login', { method: 'POST', json: body });
}

export function logout(): Promise<void> {
  return apiFetch<void>('/auth/logout', { method: 'POST' });
}

export function getMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>('/auth/me', { method: 'GET' });
}

export function changePassword(
  body: PasswordChangeRequest,
): Promise<PasswordChangeResponse> {
  return apiFetch<PasswordChangeResponse>('/auth/password', {
    method: 'POST',
    json: body,
  });
}
